import React from 'react';

import { TypographyList } from '@gogame/components';

import Item from './Item';

const MonthlyBudget = ({ monthly, circle, limit, variant, ...props }) => {
  return (
    <TypographyList
      limit={limit}
      variant={variant}
      menuVariant={variant}
      unitsLabel={'Customized'}
      zeroMinWidth={true}
      anchorProps={{ as: 'span' }}
      {...props}
    >
      {monthly?.map((opt, i) => {
        return <Item period={opt.period} amount={opt.amount} key={i} />;
      })}
    </TypographyList>
  );
};

export default MonthlyBudget;
